import { Column, Row } from 'app/design/primitives/box';
import { Text } from 'app/design/primitives/text';
import { useScopedTranslation } from 'app/hooks/i18n';
import { formatCurrency } from 'app/localization/i18n';
import type { PaymentSummaryProps } from './payment-summary';
export function PaymentSummary({ amount, subtotal, userCurrency }: PaymentSummaryProps) {
  const { t } = useScopedTranslation();
  const baseAmount = subtotal?.discountedAmount ?? subtotal?.originalAmount;
  return (
    <Row>
      <Column flex={1} gap="spacing.general.x3">
        <Text>{t('subtotal', { ns: 'payment' })}</Text>
        {subtotal?.discountAmount ? <Text>{t('discountLabel', { ns: 'payment' })}</Text> : null}
        <Text>{t('web.taxes', { ns: 'payment' })}</Text>
        <Text fontWeight="700">{t('web.total', { ns: 'payment' })}</Text>
      </Column>
      <Column gap="spacing.general.x3">
        <Text textAlign="right">{subtotal ? formatCurrency(subtotal.originalAmount / 100, userCurrency) : '-'}</Text>
        {subtotal?.discountAmount ? (
          <Text textAlign="right">-{formatCurrency(subtotal.discountAmount / 100, userCurrency)}</Text>
        ) : null}
        <Text textAlign="right">
          {baseAmount === undefined || !subtotal
            ? '-'
            : formatCurrency((baseAmount * subtotal.taxesPercentage) / 100, userCurrency)}
        </Text>
        <Text fontWeight="700" textAlign="right">
          {amount === undefined ? '-' : formatCurrency(amount / 100, userCurrency)}
        </Text>
      </Column>
    </Row>
  );
}
